import { PropChallenge, PropChallengeChallengeTypeEnum } from 'services/generatedClientFromSwagger';

/**
 * Determines if a challenge requires the activation dialog flow (KYC and/or terms & conditions).
 * - ALL Funded challenges require the dialog (for terms & conditions), regardless of requireKyc
 * - Audition challenges only require the dialog if requireKyc is true AND the user's KYC is not already completed
 */
export const doesChallengeRequireActivationFlow = (challenge?: PropChallenge, hasCompletedKyc?: boolean): boolean => {
    if (!challenge) {
        return false;
    }

    // Funded challenges require the activation flow only for terms & conditions.
    if (challenge.challengeType === PropChallengeChallengeTypeEnum.Funded) {
        return !challenge.acceptTermsAndConditions;
    }

    // Audition challenges only require the flow if they need KYC and it isn't already completed
    if (challenge.challengeType === PropChallengeChallengeTypeEnum.Audition && challenge.requireKyc) {
        // Unknown completion => be conservative and require activation
        return !hasCompletedKyc;
    }

    return false;
};
